import { html, css } from "../helpers/webComponents";

const styles: string = css`
    :host {
        position: absolute;
        top: 0;
        left: 0;
        /* height: 100vh; */
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5); 
    }

  
`;

export class PageSettingComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderSettingsDialog();

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }
        this.shadowRoot.append(element);
    }

    private renderSettingsDialog(): HTMLElement {
        const element: HTMLElement = html`
            <div>
                <style>
                    ${styles}
                </style>

                <div>
                    <game-settings></game-settings>
                </div>
            </div>
        `;
        return element;
    }
}
